
<!-- [ngClass]="{'active': item.route ? router.isActive(item.route, true): false, 'expanded': expanded}" -->

<div theme class="container"  [styleObj]='brandStyleTheme'>

  <a mat-list-item [ngStyle]="{'padding-left': (depth * 12) + 'px'}" (click)="onItemSelected(item)"
    routerLink={{item.route}} class="menu-list-item">
    <mat-icon class="routeIcon">{{item.iconName}}</mat-icon>
    <span class="menu-item-text">{{item.displayName}}</span>
    <span fxflex class="twistie-separator"></span>
    @if (item.children && item.children.length) {
      <span >
        <mat-icon class="menu-twistie" [@indicatorRotate]="expanded ? 'expanded': 'collapsed'">
          expand_more
        </mat-icon>
      </span>
    }
  </a>

  @if (expanded) {
    <div>
      @for (child of item.children; track child) {
        <app-menu-list-item class="menu-child" [item]="child" [depth]="depth + 1"></app-menu-list-item>
      }
    </div>
  }

</div>

